import { render, staticRenderFns } from "./HighVolumeUSD.vue?vue&type=template&id=d31467e0"
import script from "./HighVolumeUSD.vue?vue&type=script&lang=js"
export * from "./HighVolumeUSD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports